/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from favorites`)
};

const es_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar de favoritos`)
};

const de_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Favoriten entfernen`)
};

const nl_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen uit favorieten`)
};

const fr_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer des favoris`)
};

const it_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi dai preferiti`)
};

const pt_br2_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover dos favoritos`)
};

const pt_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover dos favoritos`)
};

const ja_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りから削除`)
};

const zh_fav_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从收藏中移除`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fav_remove = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fav_remove(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fav_remove", locale)
	if (locale === "en") return en_fav_remove(inputs)
	if (locale === "es") return es_fav_remove(inputs)
	if (locale === "de") return de_fav_remove(inputs)
	if (locale === "nl") return nl_fav_remove(inputs)
	if (locale === "fr") return fr_fav_remove(inputs)
	if (locale === "it") return it_fav_remove(inputs)
	if (locale === "pt-BR") return pt_br2_fav_remove(inputs)
	if (locale === "pt") return pt_fav_remove(inputs)
	if (locale === "ja") return ja_fav_remove(inputs)
	return zh_fav_remove(inputs)
};